import { isAdaptiveSupported } from '../preference-editors/TaxonomiesEditor';
import {
  type PreferenceScope,
  UserPreferenceKey,
  type UserPreferences,
} from '../types';

export const getDefaultPreferences = (
  scope: PreferenceScope
): UserPreferences => {
  const defaultAdaptiveTaxonomies: UserPreferences['taxonomies'] = {
    role: 'adaptive',
    skill: 'adaptive',
  };

  return {
    [UserPreferenceKey.ContingentWorkers]: false,
    [UserPreferenceKey.Taxonomies]: isAdaptiveSupported(scope)
      ? defaultAdaptiveTaxonomies
      : { role: { default: true }, skill: 0 },
    [UserPreferenceKey.DataAdjustments]: false,
    [UserPreferenceKey.Currency]: { code: 'USD', rate: 1 },
    [UserPreferenceKey.DefaultFilters]: [],
    [UserPreferenceKey.Geography]: 'msa',
  };
};
